// Import dependencies
import initialiser from '../../utils/initialiser';

const defaultSettings = {
  openClass: 'is-open',
};

class ContentExpandCollapse {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.container = el;
    this.trigger = el.querySelector(settings.trigger);
    this.content = el.querySelector(settings.content);

    // Set settings
    this.settings = { ...defaultSettings, ...settings };
  }

  // Initialisation Function
  init = () => {
    if (!this.trigger || !this.content) return;
    this.trigger.addEventListener('click', this.bindEvents);
  };

  bindEvents = () => {
    this.content.classList.toggle(this.settings.openClass);
    this.trigger.classList.toggle(this.settings.openClass);
  };
}

export default (settings) => initialiser(settings, ContentExpandCollapse);
